import { Provider } from '@angular/core';
import { DebugService } from '../services/debug.service';

export function provideSolDebug(envName: string): Provider[] {
  if (envName !== 'dit') {
    return [];
  }
  return [
    {
      provide: DebugService,
      useFactory: () => {
        return new DebugService();
      },
    },
  ];
}
